import React from 'react';
import Typography from "@material-ui/core/Typography";

const Copyright:React.FC = () => (
	<Typography variant="body2" color="textSecondary" align="center">
		{"Copyright ©"}{new Date().getFullYear()}{" PMotion"}
	</Typography>
);

export default Copyright;